import 'regenerator-runtime/runtime';
import { i18n } from './i18n';

export const typeLanguage = {
  'ptBR': 0,
  'ptPT': 1 ,
  'es': 2,
  'en': 3, 
}

export const tLang = {
  0: 'ptBR',
  1: 'ptPT',
  2: 'es',
  3: 'enUS',
}

export const language = {
  'ptBR': 'ptBR',
  'ptPT': 'ptPT',
  'es': 'es',
  'en': 'enUS', 
}

const loadTranslations = async (locale) => {
  try {
    const translations = require(`../resources/${locale}/global.js`);
    return translations.global.translation
  } catch (error) {
    console.error(`Failed to load translations for ${locale}:`, error)
    return null
  }
}

export const languageService = {
  async init() {
    const savedLang = localStorage.getItem('companyLocale');
    const dynamicLang = navigator.language.replace('-', "")

    try {
      const translations = {
        ptBR: await loadTranslations('ptBR'),
        ptPT: await loadTranslations('ptPT'),
        es: await loadTranslations('es'),
        enUS: await loadTranslations('enUS')
      }

      i18n.setLocaleMessage('ptBR', translations.ptBR)
      i18n.setLocaleMessage('ptPT', translations.ptPT)
      i18n.setLocaleMessage('es', translations.es)
      i18n.setLocaleMessage('enUS', translations.enUS)

      i18n.locale = tLang[savedLang] || language[dynamicLang];
      localStorage.setItem('companyLocale', savedLang || typeLanguage[dynamicLang])

      return dynamicLang;
    } catch (error) {
      console.error('Failed to initialize translations:', error);
      return 'ptBR';
    }
  },

  async setLanguage(lang) {
    const locale = tLang[lang];
    i18n.locale = locale;
    localStorage.setItem('companyLocale', lang);
  }
}


// WEBPACK FOOTER //
// ./src/service/languageService.js